import React from 'react';
import DriveGallery from '../../components/DriveGallery';

const PaleniCarodejnic = () => (
  <DriveGallery
    galleryId="paleni-carodejnic"
    title="Pálení čarodějnic"
    videoUrl="https://vimeo.com/1080862961?share=copy"
  />
);

export default PaleniCarodejnic;
